export enum RaffleType {
  GLOBAL = 'global',
  REGIONAL_BONUS = 'regional_bonus',
}

export enum RaffleCampaignStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  CLOSED = 'closed',
  DRAWN = 'drawn',
  APPROVED = 'approved',
}

export enum RaffleWinnerStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  DENIED = 'denied',
  NOTIFIED = 'notified',
}
